import React from "react";
import {Drawer} from "@mui/material";
import EiaThemeProvider from "../EiaThemeProvider";
import EiaCard from "../cards/EiaCard";
import {Button, Divider, Flex, Heading, Icon} from "@aws-amplify/ui-react";
import {RiCloseFill} from "react-icons/ri";

const EiaDrawer = function (props) {

    const {open, setOpen, variant, position, title} = props;

    const anchor = position ? position : "bottom";
    const onClose = () => setOpen(false);

    return(
        <div>
            <Drawer
                variant={variant}
                anchor={anchor}
                open={open}
                onClose={onClose}
                ModalProps={{
                    keepMounted: true,
                }}
            >
                <EiaThemeProvider>
                    <EiaCard>
                        <Flex direction="row" justifyContent={"space-between"}>
                            <EiaCard>
                                <Heading level={3}>{title}</Heading>
                            </EiaCard>
                            <Button size={"large"} variation={"link"} onClick={onClose}>
                                <Icon ariaLabel="Javascript" as={RiCloseFill}/>
                            </Button>
                        </Flex>
                        <Divider/>
                        <EiaCard>
                            {props.children}
                        </EiaCard>
                    </EiaCard>
                </EiaThemeProvider>
            </Drawer>
        </div>
    )
}
export default EiaDrawer;